module.exports = __webpack_public_path__ + "static/media/fairplay-logo.884a21a0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fairplay-logo.svg
// module id = 844
// module chunks = 7